var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import ReactDOM from "react-dom";
import { get } from "lodash-es";
import Foundation from "@microsoft/fast-components-foundation-react";
import { CancelIcon } from "@edge-web-ui/edge-icons";
import { Dialog as BaseDialog } from "@microsoft/fast-components-react-base";
import { Button, ButtonAppearance, Heading, HeadingSize, } from "@microsoft/fast-components-react-msft";
import { canUseDOM } from "exenv-es6";
import { classNames } from "@microsoft/fast-web-utilities";
/**
 * @deprecated - Will be removed in next major version (v5)
 * Use Dialog from @edge-web-ui/components instead
 */
class Dialog extends Foundation {
    constructor() {
        super(...arguments);
        this.handledProps = {
            closeButton: void 0,
            contentWidth: void 0,
            contentHeight: void 0,
            describedBy: void 0,
            heading: void 0,
            label: void 0,
            labelledBy: void 0,
            modal: void 0,
            managedClasses: void 0,
            onDismiss: void 0,
            primaryButton: void 0,
            secondaryButton: void 0,
            visible: void 0,
        };
        this.closeButtonElement = React.createRef();
        /**
         * Handle the close button click and keyboard events
         */
        this.handleCloseButtonClick = (e) => {
            if (typeof get(this.props, "closeButton.onInvoke") === "function") {
                this.props.closeButton.onInvoke(e);
            }
        };
    }
    /**
     * Renders the component
     */
    render() {
        const { dialog_body, dialog_heading, } = this.props.managedClasses;
        return (React.createElement(BaseDialog, Object.assign({}, this.unhandledProps(), { contentWidth: this.props.contentWidth, contentHeight: this.props.contentHeight, describedBy: this.props.describedBy, label: this.props.label, labelledBy: this.props.labelledBy, modal: this.props.modal, managedClasses: this.props.managedClasses, onDismiss: this.props.onDismiss, className: this.generateClassNames(), visible: this.props.visible }),
            this.generateCloseButton(),
            React.createElement(Heading, Object.assign({ className: classNames(dialog_heading) }, this.getHeadingProps())),
            React.createElement("div", { className: classNames(dialog_body) }, this.props.children),
            this.generateActions()));
    }
    /**
     * React life-cycle method
     */
    componentDidMount() {
        if (canUseDOM() && this.props.visible) {
            this.focusDialogCloseButton();
        }
    }
    /**
     * React life-cycle method
     */
    componentDidUpdate(prevProps) {
        if (!prevProps.visible && this.props.visible) {
            this.focusDialogCloseButton();
        }
    }
    /**
     * Generates class names
     */
    generateClassNames() {
        return super.generateClassNames(classNames([
            this.props.managedClasses.dialog__singleAction,
            !this.props.secondaryButton,
        ]));
    }
    /**
     * Set default props for the heading
     */
    getHeadingProps() {
        return Object.assign({}, { size: HeadingSize._6 }, this.props.heading);
    }
    /**
     * Set default props for the primary button
     */
    getPrimaryButtonProps() {
        return Object.assign({}, { appearance: ButtonAppearance.primary }, this.props.primaryButton);
    }
    generateCloseButton() {
        if (this.props.closeButton) {
            // Destructure the close button prop object so we can pass "unhandled" props
            const _a = this.props.closeButton, { label, onInvoke, autofocus } = _a, props = __rest(_a, ["label", "onInvoke", "autofocus"]);
            const { dialog_closeButton, dialog_closeButtonGlyph, } = this.props.managedClasses;
            return (React.createElement(Button, Object.assign({}, props, { appearance: ButtonAppearance.stealth, "aria-label": label, className: classNames(dialog_closeButton), onClick: this.handleCloseButtonClick, ref: this.closeButtonElement }),
                React.createElement(CancelIcon, { className: classNames(dialog_closeButtonGlyph) })));
        }
    }
    /**
     * Generates the dialog actions
     */
    generateActions() {
        const { dialog_actionWrapper, dialog_primaryButton, dialog_secondaryButton, } = this.props.managedClasses;
        return (React.createElement("div", { className: classNames(dialog_actionWrapper) },
            React.createElement(Button, Object.assign({ className: classNames(dialog_primaryButton) }, this.getPrimaryButtonProps())),
            this.props.secondaryButton ? (React.createElement(Button, Object.assign({ className: classNames(dialog_secondaryButton) }, this.props.secondaryButton))) : null));
    }
    /**
     * Focus the dialog close button
     */
    focusDialogCloseButton() {
        // exit out of the function if the close button doesn't exist or autofocus is set to true
        if (!this.props.closeButton || this.props.closeButton.autofocus === false) {
            return;
        }
        if (this.closeButtonElement && this.closeButtonElement.current) {
            ReactDOM.findDOMNode(this.closeButtonElement.current).focus();
        }
    }
}
Dialog.defaultProps = {
    contentHeight: "auto",
    contentWidth: "400px",
    managedClasses: {},
    visible: false,
};
Dialog.displayName = "Dialog";
export default Dialog;
export * from "./dialog.props";
